import { c as _c } from "react/compiler-runtime";
import { EllipsisIcon } from 'lucide-react';
function TriggerIcon(t0) {
  const $ = _c(7);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const t1 = `hover:bg-accent text-foreground flex cursor-pointer items-center justify-center rounded-lg bg-transparent px-1 px-2 py-1 hover:px-2 hover:py-1 sm:bg-transparent ${className}`;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <EllipsisIcon size={16} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== t1) {
    t3 = <button aria-label="Open breadcrumb menu" className={t1} {...props}>{t2}</button>;
    $[4] = props;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export { TriggerIcon };